import {Badge} from '@common-web/components/ui/badge';

export function PermissionStatusBadge({
  permission,
}: {
  permission: {source: string; isDeprecated: boolean};
}) {
  if (permission.source === 'CODE' && permission.isDeprecated) {
    return (
      <Badge className='bg-amber/10 text-amber border border-amber/30 font-medium'>
        No longer in use
      </Badge>
    );
  }
  if (permission.source === 'CODE') {
    return (
      <Badge className='bg-emerald/10 text-emerald border border-emerald/30 font-medium'>
        Active
      </Badge>
    );
  }
  return (
    <Badge className='bg-brand-blue/10 text-brand-blue border border-brand-blue/30 font-medium'>
      Custom
    </Badge>
  );
}
